export default {
    setGlobalSnackbar(state, payload) {
        state.globalSnackbar = payload;
    },

    toggleFooter(state, showFooter) {
        state.showFooter = showFooter;
    }
}